module.exports = __webpack_public_path__ + "static/media/bowling.b06ac966.png";